import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from "lodash";
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';

import { Add, AccountClose  } from '../../Common/Buttons/Icons.js';
import { Trans } from 'react-i18next';

class CheckboxesWithTextbox extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.localValidation = debounce(this.localValidation.bind(this), 500);
        this.loadSurvey = debounce(this.loadSurvey.bind(this), 500);
        this.checkResponseSelected = this.checkResponseSelected.bind(this);

        this.addpubEntry = this.addpubEntry.bind(this);
        this.removepubEntry = this.removepubEntry.bind(this);
        this.updatePubName = this.updatePubName.bind(this);
        this.checkRowCheckbox = this.checkRowCheckbox.bind(this);
        this.generatepubEntries = this.generatepubEntries.bind(this);
        this.checkIfJson = this.checkIfJson.bind(this);

        this.state = {
            pub_rows: 1,
            pub: {},
            response: [],
            errors: {1: {text: false, checkboxes: false}},
        };
    }

    componentDidMount() {
        var self = this;
        var pub = self.state.pub;
        var pub_rows = self.state.pub_rows;

        if(self.props.responses.length > 0)
        {
            self.props.responses.forEach(function (resp, index) {
                var response_found = false;
                var response_index = 1;

                Object.keys(pub).forEach(function(key, index) {
                    if(pub[key]["text"] == resp.Answer)
                    {
                        response_found = true;
                        response_index = key;
                    }
                });

                if(response_found)
                {
                    var pub_index = index + 1;
                    var pub_choice = resp.Response_Choice_Id;

                    pub[response_index][pub_choice] = true;
                }
                else
                {
                    var pub_index = Object.keys(pub).length + 1;
                    var pub_choice = resp.Response_Choice_Id;

                    pub[pub_index] = {text: resp.Answer};
                    pub[pub_index][pub_choice] = true;
                }
            });

            pub_rows = Object.keys(pub).length;

            self.setState({
                pub: pub,
                pub_rows: pub_rows
            });
        }
    }

    localValidation(e, props) {
        var pub = this.state.pub;
        var response = [];
        var keys = Object.keys(this.state.pub);
        var errors = {};

        if ($("#required_" + props.question.Id).val() === "true" && keys.length === 0) {
            errors = {1: {text: true, checkboxes: true}}
        } else {
            for (var i = 0; i < keys.length; i++) {
                var row = pub[keys[i]]
                var text_error = false;
                var checkbox_error = true;

                if (! ("text" in row) || ("text" in row && ! row["text"])) {
                    text_error = true
                }

                for (var k = 0; k < this.props.options.length; k++) {
                    if (this.props.options[k].Id in row && row[this.props.options[k].Id]) {
                        checkbox_error = false
                    }
                }
                if(checkbox_error || text_error) {
                    errors[keys[i]] = {"text": text_error, "checkboxes": checkbox_error}
                }
            }
        }

        this.setState({
            errors: errors
        })
        
        if (Object.keys(errors).length === 0) {
            
            Object.keys(pub).forEach(function(key, index) {
                Object.keys(pub[key]).forEach(function(key2, index2) {
                    if(key2 != "text")
                    {
                        response.push({"answer": key2, "answer_choice": pub[key]["text"]});
                    }
                });    
            });

            var response2 = {question_id: props.question.Id, "answer": response};
            props.handleResponse(e, props, response2);
        } 
    }

    loadSurvey(e, props, action) {
        props.loadSurvey(e, props, action);
    }

    checkResponseSelected(responses, option, value) {

        var string = "";

        if(!jQuery.isEmptyObject(responses)) {
            $.each(responses, function(i, response){
                if(response.Response_Choice_Id == option.Id) {
                    string = value;
                }
            });
        }

        return string;
    }

    addpubEntry() {
        var self = this;
        var pub_rows = self.state.pub_rows;

        if(pub_rows < 4)
        {
            pub_rows++;
        }

        self.setState({
            pub_rows: pub_rows
        });
    }

    removepubEntry(event) {
        var self = this;
        var pub = self.state.pub;
        var pub_rows = self.state.pub_rows;
        var row = event.currentTarget.dataset.row

        Object.keys(pub).forEach(function(key, index) 
        {
            if(key == row)
            {
                delete pub[row];
            }
            else if(key > row)
            {
                if(Object.keys(pub).length >= (key - 1))
                {
                    pub[(key - 1)] = pub[key];
                }

                delete pub[key];
            }
        });

        if(pub_rows > 1)
        {
            pub_rows--;
        }

        self.setState({
            pub: pub,
            pub_rows: pub_rows
        });
    }

    generatepubEntries() {
        var entries = []

        for (var count = this.state.pub_rows - 1, row = 1; count >= 0; count--, row++)
        {
            entries.push(
                <div className="survey-question-account-row">
                    <div className="mobile survey-column-header"> 
                        URL/Account Name/Publication Name
                    </div>
                    <div className="survey-question-add-row press">
                    </div>
                    <div className="survey-account-name">
                        <div className={"survey-account-container" + (row in this.state.errors && this.state.errors[row]["text"] ? " survey-account-container-error" : "")}>
                            <input type="text" className="survey-account-number" data-row={row} value={row in this.state.pub ? this.state.pub[row]["text"] : ""} onChange={(event) => this.updatePubName(event)} placeholder={ this.checkIfJson(this.props.question.Help_Text) && "placeholder" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).placeholder : "" } />
                        </div>
                        {
                            row in this.state.errors && this.state.errors[row]["text"] ? 
                                <div className="survey-errormessage">
                                    *This field is required
                                </div>
                            :
                                null
                        }
                    </div>
                    <div className="survey-question-account-number survey-option" style={{display: "flex", flexDirection: "column"}}>
                        <div style={{display: "flex", margin: "auto 0"}}>
                            {
                                this.props.options.map((option) => (
                                    <div className="survey-option-set">
                                        <div className="survey-option-checkbox centered" style={{width: "40px"}}>
                                            <label className="survey-option-checkbox-label">
                                                <input type="checkbox" id="answer_checkbox_other" data-row={row} name={option.Id} value={option.Id} checked={row in this.state.pub && option.Id in this.state.pub[row] && this.state.pub[row][option.Id]} onChange={this.checkRowCheckbox} />
                                                <span className={"survey-option-checkbox-custom" + (row in this.state.errors && this.state.errors[row]["checkboxes"] ? " survey-account-container-error" : "")}></span>
                                            </label>
                                        </div>
                                        {this.generateIcon(option, "Colour")}
                                    </div>
                                ))
                            }
                        </div>
                        {
                            row in this.state.errors && this.state.errors[row]["checkboxes"] ? 
                                <div className="survey-errormessage checkboxes-icons-errormessage">
                                    *A selection is required
                                </div>
                            :
                                null
                        }
                    </div>
                    {
                        this.state.pub_rows > 1 || 1 in this.state.pub ?
                            <div className="survey-question-remove-row press" data-row={row} onClick={(event) => this.removepubEntry(event)}>
                                {AccountClose()}
                            </div>
                        :
                            <div className="survey-question-remove-row press">
                            </div>
                    }
                </div>
            )
        }

        if(this.state.pub_rows < 4)
        {
            entries.push(
                <div className="survey-question-account-row new-account-row">
                    <div className="mobile survey-column-header">
                        URL/Account Name/Publication Name
                    </div>
                    <div className="survey-question-add-row press" onClick={() => this.addpubEntry()}>
                        {Add("fill-primary")}
                    </div>
                    <div className="survey-account-name">
                        <div className={"survey-account-container" + (row in this.state.errors ? " survey-account-container-error" : "")}>
                            <input type="text" className="survey-account-number" data-row={row} value={row in this.state.pub ? this.state.pub[row]["number"] : ""} onChange={(event) => this.updatePubName(event)} placeholder={ this.checkIfJson(this.props.question.Help_Text) && "placeholder" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).placeholder : "" } />
                        </div>
                    </div>
                    <div className="survey-question-account-number survey-option" style={{display: "flex"}}>
                        {
                            this.props.options.map((option) => (
                                <div className="survey-option-set">
                                    <div className="survey-option-checkbox centered" style={{width: "40px"}}>
                                        <label className="survey-option-checkbox-label">
                                            <input type="checkbox" id="answer_checkbox_other" value={false}/>
                                            <span className="survey-option-checkbox-custom grey"></span>
                                        </label>
                                    </div>
                                    {this.generateIcon(option, "Grey")}
                                </div>
                            ))
                        }
                    </div>
                    <div className="survey-question-remove-row press">
                    </div>
                </div>
            )
        }

        return entries;
    }

    updatePubName(event) {
        var self = this;
        var pub = self.state.pub;
        var row = event.target.dataset.row;

        if(row in pub)
        {
            pub[row].text = event.target.value;
        }
        else
        {
            pub[row] = {text: event.target.value};
        }

        self.setState({
            pub: pub,
            errors: {}
        });

        if (this.props && this.props.OnChangeHandler)
            this.props.OnChangeHandler(event, this.props)
    }

    checkRowCheckbox(event) {
        var self = this;
        var pub = self.state.pub;
        var row = event.target.dataset.row;

        if(row in pub)
        {
            pub[row][event.target.name] = event.target.checked;
        }
        else {
            pub[row] = {text: null};
            pub[row][event.target.name] = event.target.checked;
        }
        
        self.setState({
            pub: pub,
            errors: {}
        });

        if (this.props && this.props.OnChangeHandler)
            this.props.OnChangeHandler(event, this.props)
    }

    generateIcon(option, type = "Colour") {
        var icon;
        var tooltip = true;
        var tooltip_text = "";

        if (option.Text === "Print") {
            if (type === "Grey") {
                icon = <img src="/images/icons/survey/Press_Media_Grey.svg" />
            } else {
                icon = <img src="/images/icons/survey/Press_Media_Icon.svg" />
                tooltip = true;
                tooltip_text = "Hint: Printed material e.g. newspaper, magazine"
            }
        } else if (option.Text === "Video") {
            if (type === "Grey") {
                icon = <img src="/images/icons/survey/Press_Video_Grey.svg" />
            } else {
                icon = <img src="/images/icons/survey/Press_Video_Icon.svg" />
                tooltip = true;
                tooltip_text = " Hint:  Traditional or digital video e.g. television, Youtube, Vimeo"
            }
        } else if (option.Text === "Blog") {
            if (type === "Grey") {
                icon = <img src="/images/icons/survey/Press_Blog_Grey.svg" />
            } else {
                icon = <img src="/images/icons/survey/Press_Blog_Icon.svg" />
                tooltip = true;
                tooltip_text = "Hint: Website with reviews and articles"
            }
        } else if (option.Text === "Social Media") {
            if (type === "Grey") {
                icon = <img src="/images/icons/survey/Press_SocialMedia_Grey.svg" />
            } else {
                icon = <img src="/images/icons/survey/Press_SocialMedia_Icon.svg" />
                tooltip = true;
                tooltip_text = "Hint: Major platforms e.g. Facebook, Twitter, Instagram, LinkedIn"
            }
        }

        return(
            <div className="survey-checkbox-icon-container">
                <div className="survey-checkbox-icon">
                    {icon}
                    {tooltip && (
                    <>
                        <img src="/images/icons/survey/Info_Registration.svg" className="survey-checkbox-tooltip" data-tooltip tabIndex="1" data-tip={tooltip_text} data-position="bottom" data-alignment="center"/>
                        {/* <ReactTooltip effect="solid" /> */}
                    </>) }
                </div>
                <span>{option.Text}</span>
            </div>
        )
    }

    checkIfJson(json) {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }

        return true;
    }

    render() {
        return (
            <>
                <div className="registration-main">
                    <div className={"survey-questions-container question-" + (this.props.page)}>
                        <div className="survey-question-text">{ this.props.question.Text }</div>
                        <div className="survey-question-description">{ this.checkIfJson(this.props.question.Help_Text) && "description" in (JSON.parse(this.props.question.Help_Text)) ?
                                        (JSON.parse(this.props.question.Help_Text)).description : "" }</div>
                        <div className="survey-question-account">
                            <div className="survey-question-account-row">
                                <div className="survey-question-add-row press">
                                </div>
                                <div className="survey-account-name">
                                    <div className="survey-column-header desktop"><Trans>URL/Account Name/Publication Name</Trans></div>
                                </div>
                                <div className="survey-question-account-name">
                                    <div className="survey-column-header desktop"><Trans>Type of Content</Trans></div>
                                </div>
                                <div className="survey-question-remove-row press">
                                </div>
                            </div>
                            { this.generatepubEntries() }
                        </div>
                    </div>
                    <input type='hidden' name={'required_' + this.props.question.Id} id={'required_' + this.props.question.Id} value={ (this.props.question.Validation).includes("required") ? true : false }/>
                </div> 

                <div className="registration-actions">
                    {
                        this.props.question.question_orders.length == 0 || this.props.question.question_orders[0].Question_Order != 1 ?
                            <div className="registration-left">
                                <span onClick={(e) => this.loadSurvey(e, this.props, 'previous')} className="primary medium">
                                    <i className="fas fa-arrow-left" style={{marginRight: "20px"}}></i>
                                    <span><Trans>Back</Trans></span>
                                </span>
                            </div>
                        :
                            null
                    }
                    <div className="registration-right">
                        <span onClick={(e) => this.localValidation(e, this.props)} className={"primary medium registration-button " + ((this.props.question.Validation).includes("required") && jQuery.isEmptyObject(this.state.pub) ? "disabled" : "registration-active")} style={{marginLeft: "20px"}}>
                            <span><Trans>Next</Trans></span>
                            <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                        </span>
                    </div>
                </div>
            </>  
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(CheckboxesWithTextbox);